import React, { useState } from 'react';
import { Link2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useLanguage } from '../../context/LanguageContext';

export const FaidaLinkForm = ({ onSubmit, note }) => {
  const { t } = useLanguage();
  const [acct, setAcct] = useState('');
  const [ctrl, setCtrl] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await onSubmit({ account_number: acct, control_number: ctrl });
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="space-y-3 rounded-2xl border border-border bg-card p-5" data-testid="faida-link-form">
      <p className="text-sm font-semibold">{note || t('Already registered with WHI? Link your account', 'Tayari umesajiliwa WHI? Unganisha akaunti yako')}</p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Input value={acct} onChange={(e) => setAcct(e.target.value)} placeholder={t('Account number e.g. AA10071720', 'Namba ya akaunti mf. AA10071720')} required data-testid="link-account" />
        <Input value={ctrl} onChange={(e) => setCtrl(e.target.value)} placeholder={t('12-digit Control Number', 'Control Number (tarakimu 12)')} required data-testid="link-control" />
        <Button type="submit" disabled={busy} data-testid="link-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Link2 className="mr-2 h-4 w-4" />{t('Link', 'Unganisha')}</>}</Button>
      </div>
    </form>
  );
};
